import { V2_STORES } from './v2';

/**
 * Schema version 3 — one additive index. Master Phase 6.
 *
 * `sessionRepository.getSummary()` needs "every personal record achieved by
 * this session," but `personalRecords` was never indexed on `sessionId` even
 * though the field has existed on the row since v2 — a real gap, not a new
 * requirement, caught by `sessionRepository.test.ts` throwing
 * `SchemaError: KeyPath sessionId on object store personalRecords is not
 * indexed`.
 *
 * Every store except `personalRecords` is restated unchanged from
 * {@link V2_STORES} — Dexie treats each version's store map as the complete
 * schema, so omitting one would delete it. `personalRecords` gains
 * `sessionId` to its index list; nothing else about it changes.
 */
export const V3_STORES: Record<string, string> = {
  ...V2_STORES,
  personalRecords: 'id, exerciseId, sessionId, [exerciseId+kind+repCount]',
};
